import { render, staticRenderFns } from "./usage_details.vue?vue&type=template&id=66db9f8c&"
import script from "./usage_details.vue?vue&type=script&lang=js&"
export * from "./usage_details.vue?vue&type=script&lang=js&"
import style0 from "./usage_details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports